import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';
import {partnerLineOne, partnerLineTwo} from './partner';
import {certificateLineOne, certificateLineTwo} from './certificates';
import './partners.css'

function Partners() {
    const { t } = useTranslation();
   
    var settings = {
        className: "center",
        infinite: true,
        autoplay: true,
        arrows: false,
        centerMode: true,
        speed: 1200,
        responsive: [
            {
                breakpoint: 5000, // Adjust the breakpoint as needed
                settings: {
                  slidesToShow: 5,
                },
            },
            {
                breakpoint: 1125, // Adjust the breakpoint as needed
                settings: {
                  slidesToShow: 4,
                },
            },
            {
              breakpoint: 880, // Adjust the breakpoint as needed
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 500, // Adjust the breakpoint as needed
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 350, // Adjust the breakpoint as needed
              settings: {
                slidesToShow: 1,
              },
            },
        ],
    };
  return (
      <div className={`partners-section bg-light`}>
          <Container>
            <Row>
              <Col>
                <h2 className='partner-heading'>{t("partners")}</h2>
                <Slider {...settings}>
                    {partnerLineOne.map((partner, index) => (
                        <>
                            <div className='d-flex justify-content-center overflow-hidden' key={index}>
                                <img className='partnerLogo' src={partner.logo} alt={partner.name} />
                            </div>
                            <p className='partnerName d-flex justify-content-center mt-3'>{partner.name}</p>
                        </>
                    ))}
                </Slider>
              </Col>
              {/* <Col md={6}>
                <h2 className='partner-heading'>{t("certificates")}</h2>
                <Slider {...settings}>
                    {certificateLineOne.map((certificate, index) => (
                        <>
                            <div className='d-flex justify-content-center overflow-hidden' key={index}>
                                <img className='certificateLogo' src={certificate.logo} alt={certificate.name} />
                            </div>
                            <p className='partnerName d-flex justify-content-center mt-3'>{certificate.name}</p>
                        </>
                    ))}
                </Slider>
                <Slider {...settings}>
                    {certificateLineTwo.map((certificate, index) => (
                        <>
                            <div className='d-flex justify-content-center overflow-hidden' key={index}>
                                <img className='certificateLogo' src={certificate.logo} alt={certificate.name} />
                            </div>
                            <p className='partnerName d-flex justify-content-center mt-3'>{certificate.name}</p>
                        </>
                    ))}
                </Slider>
              </Col> */}
            </Row>
          </Container>
              
    </div>
  )
}

export default Partners